"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputVariants = void 0;
exports.Input = Input;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("./utils");
const class_variance_authority_1 = require("class-variance-authority");
const inputVariants = (0, class_variance_authority_1.cva)('border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50', {
    variants: {
        size: {
            default: 'h-9 px-3 py-1 text-base',
            xl: 'h-20 rounded-lg px-6 text-xl',
        },
    },
    defaultVariants: {
        size: 'default',
    },
});
exports.inputVariants = inputVariants;
function Input({ className, type, size, ...props }) {
    return ((0, jsx_runtime_1.jsx)("input", { type: type, "data-slot": "input", className: (0, utils_1.cn)(inputVariants({ size }), 'bg-background', 'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]', 'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive', className), ...props }));
}
